export default __webpack_public_path__ + "static/media/medicine-1.aca494ac.svg";